<section class="archive-vehicle-dialog">
  <div class="archive-vehicle-dialog__hero">
    <div class="archive-vehicle-dialog__icon" aria-hidden="true">
      <i class="pi pi-book"></i>
    </div>

    <div class="archive-vehicle-dialog__copy">
      <span>Archive Vehicle</span>
      <h2>{{ vehicle?.vehicle_reference || "Selected vehicle" }}</h2>
      <p>Move this vehicle into archived records.</p>
    </div>
  </div>

  <div class="archive-vehicle-dialog__details">
    <div class="archive-vehicle-dialog__detail">
      <span>Chassis No</span>
      <strong>{{ vehicle?.chassis_no || "Not captured" }}</strong>
    </div>

    <div class="archive-vehicle-dialog__detail">
      <span>Model</span>
      <strong>{{ vehicle?.model || "Not captured" }}</strong>
    </div>

    <div class="archive-vehicle-dialog__detail">
      <span>Year Model</span>
      <strong>{{ vehicle?.year_model || "Not captured" }}</strong>
    </div>
  </div>

  <div class="archive-vehicle-dialog__actions">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      (click)="close()"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-check"
      label="Archive Vehicle"
      class="p-button-sm p-button-outlined"
      (click)="confirmArchive()"
    ></button>
  </div>
</section>
